import { Box, Text, Flex, ListItem, UnorderedList } from "@chakra-ui/react";

const assetTypeToolTip = (props: any, user: any) => {
  const { payload = [] } = props;

  const formatEntryName = (entryValue: string) => {
    const words = entryValue.split(/\s+|(?<=\/)/);
    const capitalizedWords = words.map(
      (word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase(),
    );
    const capitalizedValue = capitalizedWords.join(" ");
    return capitalizedValue;
  };

  return (
    <Box
      bg="white"
      p="10px"
      borderWidth="1px"
      borderColor="gray.200"
      borderRadius={"10px"}
      background={"#717579"}
    >
      <UnorderedList listStyleType="none" m="0" p="0">
        {payload.map((entry: any, index: number) => (
          <ListItem key={`item-${index}`} my="10px" mr="0">
            <Flex alignItems="center" justifyContent="space-between">
              <Flex alignItems="center">
                <Text color="#FFF" fontWeight="500" fontSize="14px">
                  {formatEntryName(entry.name)} :
                </Text>
                <Text color="#FFF" fontWeight="500" fontSize="14px" ml={"5px"}>
                  {entry.value}
                </Text>
              </Flex>
            </Flex>
          </ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
};

export default assetTypeToolTip;
